export default __webpack_public_path__ + "static/media/IMG_20190720_200744.703e193e.jpg";